import { useObserver } from 'mobx-react';
import { useContext, useEffect } from 'react';

type _Keys = readonly (string | number | symbol)[];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type _Map<K extends readonly any[], O extends { [key in K[number]]: any }> = K extends readonly []
  ? readonly []
  : K extends readonly [infer H, ...infer T]
  ? [O[H], ..._Map<T, O>]
  : never;
interface StateInstance {
  init: () => void;
  initialized: boolean;
}

/**
 * context 化された mobx のステートから指定のものを取り出すための hooks
 * これによって React.FC 上で特定のステートをリアクティブに使用することができる
 *
 * @param context useContext した mobx の state オブジェクト
 * @param selector context から取り出したいプロパティのキーの readonly 配列
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useStateContext = <Keys extends _Keys, Store extends { [key in Keys[number]]: any } & StateInstance>(
  context: React.Context<Store>,
  selector: Keys
): _Map<Keys, Store> => {
  const state = useContext(context);
  useEffect(() => {
    if (!state.initialized) {
      state.init();
    }
  }, []);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useObserver(() => selector.map((key) => (state as any)[key])) as any;
};
